module.exports = "\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/general-info/general-info.component.css
// module id = ./src/app/profile/panels/general-info/general-info.component.css
// module chunks = main